import React from 'react';
import { ButtonSmText } from '../../text/TextComponent';
import styled from 'styled-components';

export type SecondaryButtonProps = {
	text?: string;
	onClick?: any;
	type?: 'submit' | 'button';
	disable?: boolean;
};

export const SecondaryButton = ({
	onClick,
	text = 'Back',
	type = 'button',
	disable = false,
}: SecondaryButtonProps): JSX.Element => {
	return (
		<StyledSecondaryButton disabled={disable} onClick={onClick} type={type}>
			<ButtonSmText> {text} </ButtonSmText>
		</StyledSecondaryButton>
	);
};

const StyledSecondaryButton = styled.button(
	({ theme: { color, spacing } }) => `
   	background-color: ${color.secondaryButtonBg};
   	border: 1px solid ${color.secondaryButtonBorder};
   	color: ${color.secondaryButtonColor};
	padding: ${spacing.sm} ${spacing.xxl};
	border-radius: ${spacing.xs};
	cursor: pointer;
	 &:disabled {
	 opacity: 0.5
	 }
    `
);
